export const MAIN_LOGIN_TEST_IDS = {
  // ─── Login Page ───
  pageContainer: 'main-login-page-container',
  pageCard: 'main-login-page-card',
  headerTitle: 'main-login-header-title',
  brandLogo: 'main-login-brand-logo',
  subtitleText: 'main-login-subtitle-text',
  featuresList: 'main-login-features-list',
  importantBanner: 'main-login-important-banner',
  loadingOverlay: 'main-login-loading-overlay',

  // ─── Login Form ───
  form: 'main-login-form',
  loginWithRadio: 'main-login-with-radio',
  emailInput: 'main-login-email-input',
  passwordInput: 'main-login-password-input',
  errorMessage: 'main-login-error-message',
  loginButton: 'main-login-submit-btn',
  forgotPasswordLink: 'main-login-forgot-password-link',

  // ─── Registration CTA ───
  notMemberHeading: 'main-login-not-member-heading',
  notMemberText: 'main-login-not-member-text',
  signUpButton: 'main-login-signup-btn',
} as const;
